// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
   cursor: unset !important;
   display: unset !important;
   border-color: rgba(0, 0, 0, 0.12);
   border-style: solid;
   border-width: 1px;
}

.txt-field-body {
   border-style: none;
}

.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: -5px;
   margin-left: 12px;
   margin-right: 10px;
   color: red;
}

.inline {
   display: flex;
   margin-top: -8px;
}

.mat-icon-button {
   line-height: 10px !important;
}

.div-one {
   margin-top: 12px;
}

.input-date,
.input-time,
.input-dateTime {
   width: 270px;
   padding: 5px 10px;
   margin-left: -168px !important;
}

.width-form {
   width: unset;
}

.second-date {
   color: white;
   border-color: white;
}

.div-two {
   cursor: pointer;
   margin-top: 15px;
}

.validate-error {
   border-color: red;
}

input:focus {
   outline: none !important;
   border:1px solid rgba(0, 0, 0, 0.35);
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/date/date.component.css"],"names":[],"mappings":"AAAA;GACG,wBAAwB;GACxB,yBAAyB;GACzB,iCAAiC;GACjC,mBAAmB;GACnB,iBAAiB;AACpB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG,aAAa;GACb,gBAAgB;AACnB;;AAEA;GACG,4BAA4B;AAC/B;;AAEA;GACG,gBAAgB;AACnB;;AAEA;;;GAGG,YAAY;GACZ,iBAAiB;GACjB,8BAA8B;AACjC;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,YAAY;GACZ,mBAAmB;AACtB;;AAEA;GACG,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,wBAAwB;GACxB,oCAAoC;AACvC","sourcesContent":["input {\n   cursor: unset !important;\n   display: unset !important;\n   border-color: rgba(0, 0, 0, 0.12);\n   border-style: solid;\n   border-width: 1px;\n}\n\n.txt-field-body {\n   border-style: none;\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: -5px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: red;\n}\n\n.inline {\n   display: flex;\n   margin-top: -8px;\n}\n\n.mat-icon-button {\n   line-height: 10px !important;\n}\n\n.div-one {\n   margin-top: 12px;\n}\n\n.input-date,\n.input-time,\n.input-dateTime {\n   width: 270px;\n   padding: 5px 10px;\n   margin-left: -168px !important;\n}\n\n.width-form {\n   width: unset;\n}\n\n.second-date {\n   color: white;\n   border-color: white;\n}\n\n.div-two {\n   cursor: pointer;\n   margin-top: 15px;\n}\n\n.validate-error {\n   border-color: red;\n}\n\ninput:focus {\n   outline: none !important;\n   border:1px solid rgba(0, 0, 0, 0.35);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
